// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "app" + "." + "71fa9c9166dd4f8af98e" + ".css";
};